module.exports = __webpack_public_path__ + "static/media/energy_card_pink.86ebd4ed.svg";